export const formatZip = (zip) => {
  const value = String(zip || "").trim();
  return /^\d{3,4}$/.test(value) ? value.padStart(5, "0") : value;
};

export const formatCityStateZip = ({ city, state, zip } = {}) => {
  const stateZip = [state, formatZip(zip)].filter(Boolean).join(" ");
  return [city, stateZip].filter(Boolean).join(", ");
};
